













import { defineComponent, reactive, toRefs, onMounted, ref, onBeforeUnmount } from '@vue/composition-api'
import CramStudentTable from "../../components/CramStudentTable.vue"


export default defineComponent({
  components: {
    "cram-student-table": CramStudentTable,
  },
});
